import script from "./Mask.vue?vue&type=script&setup=true&lang=js"
export * from "./Mask.vue?vue&type=script&setup=true&lang=js"

import "./Mask.vue?vue&type=style&index=0&id=0fc720e0&scoped=true&lang=css"

import exportComponent from "/home/test/projects/deploy/frontend/home/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fc720e0"]])

export default __exports__